import script from "./SEOKit.vue?vue&type=script&lang=js"
export * from "./SEOKit.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__